module.exports = {
  "key": "static-site-generators",
  "name": "Static Site Generators",
  "description": "Tools that help you generate a static site.",
  "aka": [
    "static site builder",
    "static site framework"
  ],
  "tags": [
    {
      "name": "react",
      "description": "The generator either uses React internally or encourages and supports you using it in combination with the generator."
    },
    {
      "name": "documentation"
    }
  ],
  "articles": [],
  "projects": [
    {
      "githubPath": "antwarjs/antwar",
      "description": "A static site generator built with React and Webpack.",
      "homepage": "https://antwar.js.org/",
      "dependencies": null,
      "tags": [
        "react"
      ],
      "lastStarCount": 392,
      "lastUpdatedAt": "2018-07-13T07:16:35Z",
      "avatarUrl": "https://avatars1.githubusercontent.com/u/11229036?v=4"
    },
    {
      "githubPath": "gatsbyjs/gatsby",
      "description": "⚛️📄🚀 Blazing fast static site generator for React",
      "homepage": "https://www.gatsbyjs.org",
      "dependencies": [
        "@babel/cli",
        "@babel/code-frame",
        "@babel/core",
        "@babel/parser",
        "@babel/plugin-proposal-class-properties",
        "@babel/plugin-proposal-class-properties",
        "@babel/plugin-syntax-dynamic-import",
        "@babel/plugin-transform-runtime",
        "@babel/plugin-transform-runtime",
        "@babel/polyfill",
        "@babel/preset-env",
        "@babel/preset-env",
        "@babel/preset-flow",
        "@babel/preset-flow",
        "@babel/preset-react",
        "@babel/preset-react",
        "@babel/runtime",
        "@babel/runtime",
        "@babel/traverse",
        "async",
        "autoprefixer",
        "babel-core",
        "babel-eslint",
        "babel-loader",
        "babel-plugin-add-module-exports",
        "babel-plugin-dynamic-import-node",
        "babel-plugin-remove-graphql-queries",
        "better-queue",
        "bluebird",
        "chalk",
        "chokidar",
        "common-tags",
        "convert-hrtime",
        "copyfiles",
        "core-js",
        "cross-env",
        "css-loader",
        "cssnano",
        "debug",
        "del",
        "detect-port",
        "devcert-san",
        "domready",
        "dotenv",
        "eslint",
        "eslint-config-react-app",
        "eslint-loader",
        "eslint-plugin-flowtype",
        "eslint-plugin-graphql",
        "eslint-plugin-import",
        "eslint-plugin-jsx-a11y",
        "eslint-plugin-react",
        "express",
        "express-graphql",
        "fast-levenshtein",
        "file-loader",
        "flat",
        "friendly-errors-webpack-plugin",
        "front-matter",
        "fs-extra",
        "gatsby-cli",
        "gatsby-link",
        "gatsby-plugin-page-creator",
        "gatsby-react-router-scroll",
        "glob",
        "graphql",
        "graphql-relay",
        "graphql-skip-limit",
        "graphql-type-json",
        "hash-mod",
        "history",
        "invariant",
        "is-relative",
        "is-relative-url",
        "jest",
        "jest-worker",
        "joi",
        "json-loader",
        "json-stringify-safe",
        "json5",
        "kebab-hash",
        "lerna",
        "lodash",
        "lodash-id",
        "lowdb",
        "md5",
        "md5-file",
        "mime",
        "mini-css-extract-plugin",
        "mitt",
        "mkdirp",
        "moment",
        "name-all-modules-plugin",
        "node-libs-browser",
        "normalize-path",
        "null-loader",
        "nyc",
        "opentracing",
        "opn",
        "parse-filepath",
        "path-exists",
        "physical-cpu-count",
        "postcss-flexbugs-fixes",
        "postcss-loader",
        "raw-loader",
        "react-dev-utils",
        "react-error-overlay",
        "react-hot-loader",
        "react-lifecycles-compat",
        "react-router",
        "react-router-dom",
        "redux",
        "relay-compiler",
        "request",
        "rimraf",
        "serve",
        "shallow-compare",
        "sift",
        "signal-exit",
        "slash",
        "socket.io",
        "string-similarity",
        "style-loader",
        "treeify",
        "type-of",
        "uglifyjs-webpack-plugin",
        "url-loader",
        "uuid",
        "v8-compile-cache",
        "webpack",
        "webpack-dev-middleware",
        "webpack-dev-server",
        "webpack-hot-middleware",
        "webpack-md5-hash",
        "webpack-merge",
        "webpack-stats-plugin",
        "yaml-loader"
      ],
      "tags": [
        "react"
      ],
      "lastStarCount": 23886,
      "lastUpdatedAt": "2018-07-27T21:21:56Z",
      "avatarUrl": "https://avatars1.githubusercontent.com/u/12551863?v=4"
    },
    {
      "githubPath": "nozzle/react-static",
      "description": "⚛️ 🚀 A progressive static site generator for React.",
      "homepage": "https://react-static.js.org",
      "dependencies": [
        "@babel/cli",
        "@babel/core",
        "@babel/plugin-proposal-class-properties",
        "@babel/plugin-proposal-export-default-from",
        "@babel/plugin-proposal-optional-chaining",
        "@babel/plugin-syntax-dynamic-import",
        "@babel/plugin-transform-runtime",
        "@babel/preset-env",
        "@babel/preset-react",
        "@babel/preset-stage-0",
        "@babel/register",
        "@babel/runtime",
        "@types/react",
        "@types/react-helmet",
        "@types/react-router-dom",
        "autoprefixer",
        "axios",
        "babel-core",
        "babel-jest",
        "babel-loader",
        "babel-plugin-universal-import",
        "case-sensitive-paths-webpack-plugin",
        "chalk",
        "chokidar",
        "circular-dependency-plugin",
        "commander",
        "cors",
        "css-loader",
        "download-git-repo",
        "enzyme",
        "enzyme-adapter-react-16",
        "enzyme-to-json",
        "eslint",
        "eslint-config-prettier",
        "eslint-config-react-tools",
        "eslint-plugin-babel",
        "eslint-plugin-import",
        "eslint-plugin-jsx-a11y",
        "eslint-plugin-react",
        "extract-css-chunks-webpack-plugin",
        "file-loader",
        "fs-extra",
        "git-promise",
        "glob",
        "history",
        "html-webpack-plugin",
        "husky",
        "inquirer",
        "inquirer-autocomplete-prompt",
        "jest",
        "match-sorter",
        "openport",
        "optimize-css-assets-webpack-plugin",
        "postcss-flexbugs-fixes",
        "postcss-loader",
        "preact",
        "preact-compat",
        "prettier",
        "pretty-error",
        "progress",
        "prop-types",
        "raf",
        "raw-loader",
        "react",
        "react-dev-utils",
        "react-dom",
        "react-helmet",
        "react-hot-loader",
        "react-router",
        "react-router-dom",
        "react-universal-component",
        "resolve-from",
        "rimraf",
        "serve",
        "shorthash",
        "slash",
        "socket.io",
        "socket.io-client",
        "style-loader",
        "swimmer",
        "uglifyjs-webpack-plugin",
        "update-notifier",
        "url-loader",
        "webpack",
        "webpack-bundle-analyzer",
        "webpack-dev-server",
        "webpack-flush-chunks",
        "webpack-node-externals"
      ],
      "tags": [
        "react"
      ],
      "lastStarCount": 5312,
      "lastUpdatedAt": "2018-07-27T19:38:20Z",
      "avatarUrl": "https://avatars2.githubusercontent.com/u/5400727?v=4"
    },
    {
      "githubPath": "jnordberg/wintersmith",
      "description": "A flexible static site generator",
      "homepage": "http://wintersmith.io/",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 3357,
      "lastUpdatedAt": "2018-07-27T17:53:55Z",
      "avatarUrl": "https://avatars3.githubusercontent.com/u/95886?v=4"
    },
    {
      "githubPath": "static-dev/spike",
      "description": ":cactus: A modern static build tool, powered by webpack",
      "homepage": "http://spike.js.org",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 421,
      "lastUpdatedAt": "2018-07-27T16:30:47Z",
      "avatarUrl": "https://avatars1.githubusercontent.com/u/19313279?v=4"
    },
    {
      "githubPath": "phenomic/phenomic",
      "description": "Modular website compiler (React, Webpack, Reason and whatever you want) ⚡️",
      "homepage": "https://phenomic.io/",
      "dependencies": [
        "babel-cli",
        "babel-eslint",
        "babel-plugin-transform-runtime",
        "babel-preset-env",
        "babel-preset-react",
        "babel-preset-stage-1",
        "bs-platform",
        "chalk",
        "cross-env",
        "cross-spawn",
        "eslint",
        "eslint-config-i-am-meticulous",
        "eslint-import-resolver-webpack",
        "eslint-plugin-flowtype",
        "eslint-plugin-import",
        "eslint-plugin-react",
        "eslint-plugin-react-native",
        "flow-bin",
        "git-exec-and-restage",
        "globby",
        "husky",
        "jest",
        "lerna",
        "lint-staged",
        "npm-run-all",
        "prettier",
        "trash-cli"
      ],
      "tags": [],
      "lastStarCount": 3044,
      "lastUpdatedAt": "2018-07-25T23:31:43Z",
      "avatarUrl": "https://avatars0.githubusercontent.com/u/28756976?v=4"
    },
    {
      "githubPath": "segmentio/metalsmith",
      "description": "An extremely simple, pluggable static site generator.",
      "homepage": "http://metalsmith.io",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 6862,
      "lastUpdatedAt": "2018-07-27T09:55:09Z",
      "avatarUrl": "https://avatars0.githubusercontent.com/u/819518?v=4"
    },
    {
      "githubPath": "sintaxi/harp",
      "description": "Static Site Server/Generator with built-in preprocessing",
      "homepage": "http://harpjs.com",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 4691,
      "lastUpdatedAt": "2018-07-27T16:08:58Z",
      "avatarUrl": "https://avatars2.githubusercontent.com/u/867?v=4"
    },
    {
      "githubPath": "assemble/assemble",
      "description": "Get the rocks out of your socks! Assemble makes you fast at creating code projects. Gulp- and grunt-friendly.  Used by thousands of projects for rapid prototyping, creating themes, scaffolds, boilerplates, e-books, UI components, API documentation, blogs, building websites/static site generator, an alternative to Jekyll for gh-pages and more! ",
      "homepage": "http://assemble.io/",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 3570,
      "lastUpdatedAt": "2018-07-26T01:33:05Z",
      "avatarUrl": "https://avatars0.githubusercontent.com/u/2645080?v=4"
    },
    {
      "githubPath": "docpad/docpad",
      "description": "Empower your website frontends with layouts, meta-data, pre-processors (markdown, jade, coffeescript, etc.), partials, skeletons, file watching, querying, and an amazing plugin system. DocPad will streamline your web development process allowing you to craft full-featured websites quicker than ever before.",
      "homepage": "https://docpad.org",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 2971,
      "lastUpdatedAt": "2018-07-27T17:53:22Z",
      "avatarUrl": "https://avatars1.githubusercontent.com/u/1865439?v=4"
    },
    {
      "githubPath": "hexojs/hexo",
      "description": "A fast, simple & powerful blog framework, powered by Node.js.",
      "homepage": "https://hexo.io",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 22953,
      "lastUpdatedAt": "2018-07-27T15:26:57Z",
      "avatarUrl": "https://avatars0.githubusercontent.com/u/6375567?v=4"
    },
    {
      "githubPath": "lord/slate",
      "description": "Beautiful static documentation for your API",
      "homepage": "https://spectrum.chat/slate",
      "dependencies": null,
      "tags": [
        "documentation"
      ],
      "lastStarCount": 23994,
      "lastUpdatedAt": "2018-07-27T21:10:56Z",
      "avatarUrl": "https://avatars0.githubusercontent.com/u/1976330?v=4"
    },
    {
      "githubPath": "markdalgleish/static-site-generator-webpack-plugin",
      "description": "Minimal, unopinionated static site generator powered by webpack",
      "homepage": null,
      "dependencies": null,
      "tags": [],
      "lastStarCount": 1321,
      "lastUpdatedAt": "2018-07-24T14:41:37Z",
      "avatarUrl": "https://avatars2.githubusercontent.com/u/696693?v=4"
    },
    {
      "githubPath": "GitbookIO/gitbook",
      "description": "📝 Modern documentation format and toolchain using Git and Markdown",
      "homepage": "https://www.gitbook.com",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 18816,
      "lastUpdatedAt": "2018-07-27T20:36:48Z",
      "avatarUrl": "https://avatars0.githubusercontent.com/u/7111340?v=4"
    },
    {
      "githubPath": "elmasse/nextein",
      "description": "A static site generator with markdown + react for Next.js",
      "homepage": "https://nextein.now.sh",
      "dependencies": null,
      "tags": [
        "react"
      ],
      "lastStarCount": 641,
      "lastUpdatedAt": "2018-07-27T02:09:06Z",
      "avatarUrl": "https://avatars0.githubusercontent.com/u/223235?v=4"
    },
    {
      "githubPath": "flatiron/blacksmith",
      "description": "A generic static site generator built using flatiron, plates, and marked.",
      "homepage": "",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 572,
      "lastUpdatedAt": "2018-07-27T17:52:40Z",
      "avatarUrl": "https://avatars3.githubusercontent.com/u/624259?v=4"
    },
    {
      "githubPath": "eduardoboucas/staticman",
      "description": "💪  Static sites with superpowers",
      "homepage": "https://staticman.net",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 1065,
      "lastUpdatedAt": "2018-07-26T14:02:35Z",
      "avatarUrl": "https://avatars3.githubusercontent.com/u/4162329?v=4"
    },
    {
      "githubPath": "vigetlabs/blendid",
      "description": "A delicious blend of gulp tasks combined into a configurable asset pipeline and static site builder",
      "homepage": "",
      "dependencies": null,
      "tags": [],
      "lastStarCount": 4984,
      "lastUpdatedAt": "2018-07-26T20:29:05Z",
      "avatarUrl": "https://avatars2.githubusercontent.com/u/4845?v=4"
    }
  ]
}


//////////////////
// WEBPACK FOOTER
// ./~/javascriptstuff-db/static-site-generators.js
// module id = 784
// module chunks = 77397677160559